module.exports = __webpack_public_path__ + "static/intro-bg-b6c7fafdb1f51812cee605cfc15f8b2f.png";